import React, { useEffect, useState } from "react";
import CustomerInfo from "./CustomerInfo";
import AddressDetails from "./AddressDetails";
import {
  getCurrentWorkspaceId,
  startApiCall,
} from "../../../../global-functions/globalFunctions";
import ApiCall from "../../../../api/ApiCall";
import { CustomerRelatedEndPoints } from "../../../../api/Endpoints";
import { toast } from "react-toastify";

const AddCustomer = ({
  handleGetAllCustomer,
  editCustomer,
  setEditCustomer,
}) => {
  const [loader, setloader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Customer Info
  const [step1, setStep1] = useState(true);
  const [customerType, setCustomerType] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [countryCode, setcountryCode] = useState("");

  const completeFirstStep =
    customerType && name && email && phone?.length === 10 ? true : false;
  // const completeFirstStep =
  // customerType === "business" ? (gstNo && name && email && phone ? true : false) : customerType && name && email && phone ? true : false;

  // Address Details
  const [step2, setStep2] = useState(false);
  const [isSameAddress, setIsSameAddress] = useState("");
  const [billingAddress, setBillingAddress] = useState({
    country: "",
    city: "",
    zipCode: "",
    address: "",
  });

  const [shippingAddress, setShippingAddress] = useState({
    country: "",
    city: "",
    zipCode: "",
    address: "",
  });

  const handleChangeBillingAddress = (e) => {
    const { name, value } = e.target;
    setBillingAddress({
      ...billingAddress,
      [name]: value,
    });
  };

  const handleChangeShippingAddress = (e) => {
    const { name, value } = e.target;
    setShippingAddress({
      ...shippingAddress,
      [name]: value,
    });
  };

  const selectSetup1 = () => {
    setStep1(true);
    setStep2(false);
  };

  const selectSetup2 = () => {
    setStep1(false);
    setStep2(true);
  };

  useEffect(() => {
    if (editCustomer) {
      setCustomerType(editCustomer?.customerType);
      setName(editCustomer?.name);
      setPhone(editCustomer?.phone);
      setEmail(editCustomer?.email);
      setBillingAddress({
        country: editCustomer?.billingAddress?.country,
        city: editCustomer?.billingAddress?.city,
        zipCode: editCustomer?.billingAddress?.pinCode,
        address: editCustomer?.billingAddress?.street,
      });
      setShippingAddress({
        country: editCustomer?.shippingAddress?.country,
        city: editCustomer?.shippingAddress?.city,
        zipCode: editCustomer?.shippingAddress?.pinCode,
        address: editCustomer?.shippingAddress?.street,
      });
      setcountryCode(
        editCustomer?.countryCode ? editCustomer?.countryCode : ""
      );
      setPanNo(editCustomer?.pan);
      const billingSameAsShipping =
        editCustomer?.billingAddress &&
        editCustomer?.shippingAddress &&
        editCustomer.billingAddress.country ===
          editCustomer.shippingAddress.country &&
        editCustomer.billingAddress.city ===
          editCustomer.shippingAddress.city &&
        editCustomer.billingAddress.pinCode ===
          editCustomer.shippingAddress.pinCode &&
        editCustomer.billingAddress.street ===
          editCustomer.shippingAddress.street;

      setIsSameAddress(billingSameAsShipping);
    }
  }, [editCustomer]);

  const handleReset = () => {
    setErrorMessage("");
    setloader(false);
    selectSetup1();
    setCustomerType("");
    setName("");
    setEmail("");
    setPhone("");
    setPanNo("");
    setGstNo("");
    setcountryCode("");
    setBillingAddress({
      country: "",
      city: "",
      zipCode: "",
      address: "",
    });
    setShippingAddress({
      country: "",
      city: "",
      zipCode: "",
      address: "",
    });
    setIsSameAddress("");
    setEditCustomer("");
    const closeModalDom = document.getElementById("add_customer");
    if (closeModalDom) closeModalDom.click();
  };

  // ADD CUSTOMER FUNCTION API CALL
  const handleAddCustomer = async (e) => {
    e.preventDefault();
    startApiCall(setErrorMessage, setloader);
    const sendData = {
      businessId: getCurrentWorkspaceId(),
      customerType,
      name,
      email,
      phone,
      pan: panNo,
      gst: gstNo,
      billingPinCode: billingAddress.zipCode,
      billingCountry: billingAddress.country,
      billingCity: billingAddress.city,
      billingStreet: billingAddress.address,
      shippingPinCode: shippingAddress.zipCode,
      shippingCountry: shippingAddress.country,
      shippingCity: shippingAddress.city,
      shippingStreet: shippingAddress.address,
      countryCode: countryCode,
    };
    const res = await ApiCall(
      "post",
      CustomerRelatedEndPoints.addCustomer,
      sendData
    );
    if (res?.success) {
      handleReset();
      handleGetAllCustomer();
      toast.success("Add customer successfully!");
    } else {
      setloader(false);
      setErrorMessage(res.error);
    }
  };

  // EDIT CUSTOMER FUNCTION API CALL
  const handleEditCustomer = async (e) => {
    e.preventDefault();
    startApiCall(setErrorMessage, setloader);
    const sendData = {
      customerId: editCustomer?._id,
      name,
      phone,
      pan: panNo,
      gst: gstNo,
      billingPinCode: billingAddress.zipCode,
      billingCountry: billingAddress.country,
      billingCity: billingAddress.city,
      billingStreet: billingAddress.address,
      shippingPinCode: shippingAddress.zipCode,
      shippingCountry: shippingAddress.country,
      shippingCity: shippingAddress.city,
      shippingStreet: shippingAddress.address,
      countryCode: countryCode,
    };
    const res = await ApiCall(
      "post",
      CustomerRelatedEndPoints.editCustomer,
      sendData
    );
    if (res?.success) {
      toast.success("Edit customer successfully!");
      handleGetAllCustomer();
      handleReset();
    } else {
      setloader(false);
      setErrorMessage(res.error);
    }
  };

  return (
    <div
      id="add_customer"
      className="modal fade add-new-task"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: "70%", zIndex: -1 }}
      >
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleReset}
            >
              <span aria-hidden="true">×</span>
            </button>
            <h5>{editCustomer !== "" ? "Edit Customer" : "Add Customer"}</h5>
            <div className="border-top mb-2"></div>
            <div className="d-flex gap-3 p-2 px-2">
              <div className="d-flex flex-column gap-3 border rounded-7 p-3 w-260p h-100">
                <p className="text-dark fw-semibold">2 step set up</p>
                <div className="d-flex align-items-center gap-3">
                  <span
                    className={`border bg-${
                      completeFirstStep ? "success" : "light"
                    } circle d-flex align-items-center justify-content-center text-dark`}
                    style={{ height: "28px", width: "28px" }}
                  >
                    {step1 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check2"
                        viewBox="0 0 16 16"
                      >
                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                      </svg>
                    ) : (
                      1
                    )}
                  </span>
                  <p className="text-dark">Basic information</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <span
                    className="border bg-light circle d-flex align-items-center justify-content-center text-dark"
                    style={{ height: "28px", width: "28px" }}
                  >
                    {step2 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check2"
                        viewBox="0 0 16 16"
                      >
                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                      </svg>
                    ) : (
                      2
                    )}
                  </span>
                  <p className="text-dark">Address</p>
                </div>
              </div>

              {step1 && !step2 && (
                <CustomerInfo
                  selectSetup2={selectSetup2}
                  customerType={customerType}
                  setCustomerType={setCustomerType}
                  name={name}
                  setName={setName}
                  email={email}
                  setEmail={setEmail}
                  phone={phone}
                  setPhone={setPhone}
                  completeFirstStep={completeFirstStep}
                  editCustomer={editCustomer}
                  gstNo={gstNo}
                  setGstNo={setGstNo}
                  panNo={panNo}
                  setPanNo={setPanNo}
                  setcountryCode={setcountryCode}
                  countryCode={countryCode}
                />
              )}

              {!step1 && step2 && (
                <AddressDetails
                  selectSetup1={selectSetup1}
                  billingAddress={billingAddress}
                  handleChangeBillingAddress={handleChangeBillingAddress}
                  shippingAddress={shippingAddress}
                  handleChangeShippingAddress={handleChangeShippingAddress}
                  handleAddCustomer={handleAddCustomer}
                  loader={loader}
                  errorMessage={errorMessage}
                  handleEditCustomer={handleEditCustomer}
                  editCustomer={editCustomer}
                  setShippingAddress={setShippingAddress}
                  isSameAddress={isSameAddress}
                  setIsSameAddress={setIsSameAddress}
                  setBillingAddress={setBillingAddress}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomer;
